module.exports = __webpack_public_path__ + "img/05_hpi.48b5c5f4.jpg";